import HsIndividualResourceActivityDetails from './component'
export default HsIndividualResourceActivityDetails
